module.exports = __webpack_public_path__ + "static/media/brandon.9c93ec04.jpg";